import Vue from 'vue';
import VueI18n from 'vue-i18n';

import moment from 'moment';

import fr from './lang/fr.json';
import en from './lang/en.json';

Vue.use(VueI18n);

const messages = {
  en,
  fr,
};

const userLangGeo = navigator.language || navigator.userLanguage;
const userLang = userLangGeo.split('-')[0];

moment.locale(`${userLang}_CA`);

export default new VueI18n({
  locale: userLang,
  messages,
});
